import type { FC } from "react";

import Ring from "@shared/assets/genericLoader/LoadingRing.svg";
import Logo from "@shared/assets/genericLoader/LoadingRingLogo.svg";

import {
  innerRingStyle,
  logoStyle,
  middleRingStyle,
  outerRingStyle,
  style,
} from "./GenericLoader.styles";

const GenericLoader: FC = () => (
  <div css={style} aria-live="assertive" role="alert">
    <Ring key="outer" css={outerRingStyle} />
    <Ring key="middle" css={middleRingStyle} />
    <Ring key="inner" css={innerRingStyle} />
    <Logo css={logoStyle} />
  </div>
);

export { GenericLoader };
